import MGTTRoute from './MGTTRoute'

const routes = [
    new MGTTRoute()
]

export default routes